module.exports = __webpack_public_path__ + "img/flavor_lime.7aa68786.png";